import general from "./general";

export const ringSettingParams:Record<string, string> =  {
    Ring_Style: general.RING_STYLE,
    Diamond_Shape: general.SHAPE,
    Diamond_Type: general.TYPE,
    Center_Diamond_Size:general.CARAT,
    Ring_Crown: general.CROWN,
    Ring_Side:general.SIDE,
    Metal_Color:general.METAL,
    Crown_Metal_Color: general.CROWN_METAL,
    Ring_Size: general.SIZE,
    Wedding_Band: general.BAND,
    Side_Stones:general.Side_Stones,
    Earring_Back:general.Earring_Back,
    Diamond_Quality: general.Diamond_Quality,
}

export const studExtraImageView: Record<string, string> = {
    "BTF": "V6",
    "SCW": "V7",
    "GRD": "V8"
}

export const imageColor = (view: string) => {
    return "fafafa"
}

export const NEWNESS_FILTER_CODE = 'NEWNESS';
export const NEWNESS_FILTER_LABEL = 'Newness';
export const NEWNESS_FILTER_PARAM = 'is_newness';